export default {
  callerCall: 'Caller',
  transferCall: 'Transfer',
} as const;
